var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactAddress = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20.0002C0.5 9.23069 9.23045 0.500244 20 0.500244H28C38.7696 0.500244 47.5 9.23069 47.5 20.0002V28.0002C47.5 38.7698 38.7696 47.5002 28 47.5002H20C9.23045 47.5002 0.5 38.7698 0.5 28.0002V20.0002Z",
    fill: "white",
    stroke: "#DDE2EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19.0002,
    width: 7,
    height: 7,
    fill: "#C59331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.2502C25.9891 15.2502 27.8968 16.0404 29.3033 17.4469C30.7098 18.8535 31.5 20.7611 31.5 22.7502C31.5 26.334 29.0812 29.6327 24.335 32.6527C24.2348 32.7163 24.1186 32.7501 24 32.7501C23.8814 32.7501 23.7652 32.7163 23.665 32.6527C18.9187 29.6327 16.5 26.334 16.5 22.7502C16.5 20.7611 17.2902 18.8535 18.6967 17.4469C20.1032 16.0404 22.0109 15.2502 24 15.2502ZM24 20.2502C23.337 20.2502 22.7011 20.5136 22.2322 20.9825C21.7634 21.4513 21.5 22.0872 21.5 22.7502C21.5 23.4133 21.7634 24.0492 22.2322 24.518C22.7011 24.9869 23.337 25.2502 24 25.2502C24.663 25.2502 25.2989 24.9869 25.7678 24.518C26.2366 24.0492 26.5 23.4133 26.5 22.7502C26.5 22.0872 26.2366 21.4513 25.7678 20.9825C25.2989 20.5136 24.663 20.2502 24 20.2502Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactAddress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contactAddress.d3582257648e8de1d48f8f0f7fd3dcae.svg";